<template>
  <div class="grid gap-y-sm">
    <div class="dossier " v-for="idx in 5">
      <span class="ant-avatar animate-pulse"></span>
      <div class="grid gap-y-xxs">
        <span class="title animate-pulse"></span>
        <span class="dob animate-pulse"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkeletonResults.vue"
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';

.animate-pulse {
  animation: pulse 1s cubic-bezier(0.4, 0, 0.6, 1) infinite;

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: .5;
    }
  }
}
.ant-avatar {
  background-color: white;
}

.title {
  background-color: white;
  width: 20ch;
  border-radius: 9999px;
  height: $font-size-base;
}
.dob {
  background-color: white;
  width: 12ch;
  border-radius: 9999px;
  height: $font-size-small;
}
.dossier {
  background-color: $main-content-bg-color;
  border-right: $border-radius-base;
  padding: $spacing-xxs $spacing-xs;
  font-size: $font-size-small;
  border-radius: $border-radius-base;
  color: $text-color;
  display: flex;
  gap: $spacing-sm;

}
</style>
